import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13f9b19d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "OrgManagementHeader",
  class: /*#__PURE__*/_normalizeClass(`!tw-z-[1070]`)
}
const _hoisted_2 = { id: "left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo tw-cursor-pointer",
  src: "/img/CyberSystemLogo.svg",
  alt: "LOGO"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { id: "right" }
const _hoisted_6 = { class: "tw-mr-[7px]" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "tw-text-[#211F58] tw-text-[12px] tw-font-medium tw-mb-[5px]" }
const _hoisted_9 = { class: "tw-text-[#878787] tw-text-[11px] tw-font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_active_org_drop_down = _resolveComponent("active-org-drop-down")!
  const _component_global_search = _resolveComponent("global-search")!
  const _component_notification_handler = _resolveComponent("notification-handler")!
  const _component_GlobalAvatar = _resolveComponent("GlobalAvatar")!
  const _component_custom_drop_down_item = _resolveComponent("custom-drop-down-item")!
  const _component_ButtonShowMore = _resolveComponent("ButtonShowMore")!
  const _component_ProfileModal = _resolveComponent("ProfileModal")!

  return (_openBlock(), _createBlock(_KeepAlive, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          href: "/dashboard",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLinkToDashboard && _ctx.onLinkToDashboard(...args)))
        }, _hoisted_4),
        _createElementVNode("span", null, [
          _createVNode(_component_active_org_drop_down, {
            "status-setup-modal": _ctx.statusSetupModal,
            "user-data": _ctx.userPayload
          }, null, 8, ["status-setup-modal", "user-data"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_global_search, {
          class: "search",
          onOnClickInputSearch: _ctx.onClickInputSearch
        }, null, 8, ["onOnClickInputSearch"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_notification_handler, {
            "notification-count": _ctx.notificationCount,
            onClick: _ctx.emitNotification
          }, null, 8, ["notification-count", "onClick"])
        ]),
        _createVNode(_component_ButtonShowMore, {
          "id-popover": 'popover-button-show-more-org-management-header',
          "is-from-notification": true,
          "dropdown-class": "!tw-top-[54px] tw--min-w-[126px] tw-max-w-[252px]",
          placement: "bottom-end"
        }, {
          icon: _withCtx(() => [
            (_ctx.urlAvatar === null)
              ? (_openBlock(), _createBlock(_component_GlobalAvatar, {
                  key: 0,
                  id: "menu-global-avatar-user",
                  "data-cy": "menu-global-avatar-user",
                  class: "tw-cursor-pointer",
                  name: _ctx.user?.fullName || _ctx.user?.email,
                  "class-name": 'user-icon'
                }, null, 8, ["name"]))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.urlAvatar,
                  "data-cy": "menu-global-avatar-user",
                  alt: "user",
                  class: "user-icon"
                }, null, 8, _hoisted_7))
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              "data-cy": "app-header-nav-user-info",
              class: _normalizeClass(`${
              _ctx.planOrgDetail ? 'tw-cursor-pointer' : 'cursor-pointer-unset'
            } tw-flex tw-flex-col !tw-p-[15px] normal-text hover:tw-bg-[#F2F8FF80]`),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openProfileModal && _ctx.openProfileModal(...args)))
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.user?.fullName || _ctx.user?.email), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user?.company), 1)
            ], 2),
            _createVNode(_component_custom_drop_down_item, {
              padding: `tw-px-[15px] tw-pb-[15px]`,
              "data-cy": "app-header-nav-log-out",
              style: 'danger',
              "style-text": 'tw-pt-[12px]',
              "id-text": 'app-header-nav-log-out-title-1',
              onClick: _ctx.logout
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createElementVNode("span", {
          class: _normalizeClass(`${
            _ctx.planOrgDetail ? 'tw-cursor-pointer' : 'cursor-pointer-unset'
          } three-dots-wrapper tw-ml-[8px]`),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitMenuDots && _ctx.emitMenuDots(...args)))
        }, [
          _createElementVNode("img", {
            src: "/img/menu_dots.svg",
            alt: "menu",
            class: _normalizeClass(`menu-icon ${
              _ctx.planOrgDetail ? 'tw-cursor-pointer' : 'cursor-pointer-unset'
            }`)
          }, null, 2)
        ], 2)
      ]),
      _createVNode(_component_ProfileModal, {
        class: "tw-px-[0px]",
        "is-visible": _ctx.isProfileModalVisible,
        "is-internal": _ctx.isInternal,
        profile: _ctx.user,
        "existing-profile": _ctx.currentUser,
        "is-current-user": true,
        onClose: _ctx.closeProfileModal,
        onShowModal: _ctx.openActionModal,
        onShowModalMFA: _ctx.showMFA
      }, null, 8, ["is-visible", "is-internal", "profile", "existing-profile", "onClose", "onShowModal", "onShowModalMFA"])
    ])
  ], 1024))
}